import React, { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import {
  Card,
  CardGroup,
  CardBody,
  CardHeader,
  CardHeaderBtn,
} from "./../../components/card/card.jsx";

function EmailDetail() {
  const [mailData, setMailData] = useState([]);
  const [selectedMailData, setSelectedMailData] = useState(null);

  const accessToken = "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3"; // El token de acceso
  const apiUrl = "https://api.checkmark.mx/vehiculos/consultar"; // La URL de la API

  // Función para obtener los datos desde la API
  const fetchData = async () => {
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          access_token: accessToken,
        }),
      });

      const data = await response.json();
      console.log("Respuesta de la API:", data); // Log para depuración

      if (data.statusCode === 200) {
        if (Array.isArray(data.data) && data.data.length > 0) {
          // Procesar los datos
          const processedData = data.data.map((cliente) => {
            let productos = [];

            if (cliente.plan_accesorios) {
              try {
                // Parsear `plan_accesorios` si es un JSON válido
                const accesorio = JSON.parse(cliente.plan_accesorios);
                productos = Array.isArray(accesorio) ? accesorio : [accesorio];
              } catch (error) {
                console.error(
                  `Error al parsear plan_accesorios para el cliente con ID ${cliente.id}:`,
                  error
                );
              }
            }

            return {
              ...cliente,
              productos, // Añadir los productos procesados al cliente
            };
          });

          setMailData(processedData);
        } else {
          console.error("No hay registros disponibles.");
        }
      } else {
        console.error(
          "Error al obtener los datos:",
          data.message || "Sin mensaje de error."
        );
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
    }
  };

  // Llama a `fetchData` cuando se monte el componente
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="mailbox">
      <div className="mailbox-toolbar">
        <div className="mailbox-toolbar-item">
          <span className="mailbox-toolbar-text">Deals</span>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/detail" className="mailbox-toolbar-link active">
            Clientes
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/create" className="mailbox-toolbar-link">
            Entrevista
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/analytics" className="mailbox-toolbar-link">
            Analítica
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/tools" className="mailbox-toolbar-link">
            Tools
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/contract" className="mailbox-toolbar-link">
            Contrato
          </Link>
        </div>
      </div>
      <div className="mailbox-body">
        <div className="mailbox-sidebar" style={{ height: "400px" }}>
          <PerfectScrollbar className="h-100">
            <div className="mailbox-list">
              {mailData && mailData.length > 0 ? (
                mailData.map((registro, index) => (
                  <div
                    key={index}
                    className="mailbox-list-item"
                    onClick={() => setSelectedMailData(registro)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="mailbox-message">
                      <div className="mailbox-sender">
                        <span className="mailbox-sender-name">
                          {registro.nombre} {registro.apellido}
                        </span>
                        <span className="mailbox-time">
                          {registro.created_at}
                        </span>
                      </div>
                      <div className="mailbox-title">
                        {registro.marca} {registro.modelo} - {registro.anio}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div
                  className="mailbox-list-item"
                  style={{ minWidth: "360px" }}
                >
                  No hay registros
                </div>
              )}
            </div>
          </PerfectScrollbar>
        </div>

        <div className="mailbox-content">
          <PerfectScrollbar className="h-100">
            {selectedMailData ? (
              <div className="mailbox-detail">
                <div className="table-container">
                  <Card>
                    <CardHeader className="with-btn">
                      Deals
                      <CardHeaderBtn />
                    </CardHeader>
                    <CardBody>
                      <CardGroup className="m-n1">
                        <Card className="m-1">
                          <CardBody>
                            <h5 className="card-title">
                              <i className="fas fa-lg fa-fw me-2 fa-user"></i>
                              Cliente
                            </h5>
                            <table className="table table-striped mb-0">
                              <tbody>
                                <tr>
                                  <td>Nombre</td>
                                  <td>
                                    {selectedMailData.nombre}{" "}
                                    {selectedMailData.apellido}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Teléfono</td>
                                  <td>{selectedMailData.telefono}</td>
                                </tr>
                                <tr>
                                  <td>Código Postal</td>
                                  <td>{selectedMailData.codigo_postal}</td>
                                </tr>
                                <tr>
                                  <td>Correo</td>
                                  <td>{selectedMailData.correo}</td>
                                </tr>
                                <tr>
                                  <td>Comentario</td>
                                  <td>{selectedMailData.comentario}</td>
                                </tr>
                                <tr>
                                  <td>Motivo de Rechazo</td>
                                  <td>{selectedMailData.motivo_rechazo}</td>
                                </tr>
                                <tr>
                                  <td>Fecha de Registro</td>
                                  <td>{selectedMailData.created_at}</td>
                                </tr>
                              </tbody>
                            </table>
                          </CardBody>
                        </Card>
                        <Card className="m-1">
                          <CardBody>
                            <h5 className="card-title">
                              <i className="fas fa-lg fa-fw me-2 fa-car"></i>
                              Vehículo
                            </h5>
                            <table className="table table-striped mb-0">
                              <tbody>
                                <tr>
                                  <td>Marca</td>
                                  <td>{selectedMailData.marca}</td>
                                </tr>
                                <tr>
                                  <td>Modelo</td>
                                  <td>{selectedMailData.modelo}</td>
                                </tr>
                                <tr>
                                  <td>Año</td>
                                  <td>{selectedMailData.anio}</td>
                                </tr>
                                <tr>
                                  <td>Versión</td>
                                  <td>{selectedMailData.version}</td>
                                </tr>
                                <tr>
                                  <td>Condición</td>
                                  <td>{selectedMailData.condicion}</td>
                                </tr>
                                <tr>
                                  <td>Precio Total</td>
                                  <td>
                                    $
                                    {new Intl.NumberFormat("es-MX", {
                                      style: "decimal",
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 0,
                                    }).format(selectedMailData.precio_total)}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Financiamiento Meses</td>
                                  <td>
                                    {selectedMailData.financiamiento_meses}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Enganche Porcentaje</td>
                                  <td>
                                    {selectedMailData.enganche_porcentaje}%
                                  </td>
                                </tr>
                                <tr>
                                  <td>Mensualidad Estimada</td>
                                  <td>
                                    $
                                    {new Intl.NumberFormat("es-MX", {
                                      style: "decimal",
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 0,
                                    }).format(
                                      selectedMailData.mensualidad_estimada
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </CardBody>
                        </Card>
                        <Card className="m-1">
                          <CardBody>
                            <h5 className="card-title">
                              <i className="fas fa-lg fa-fw me-2 fa-box"></i>
                              Productos
                            </h5>
                            <table className="table table-striped mb-0">
                              <tbody>
                                {selectedMailData &&
                                selectedMailData.productos &&
                                selectedMailData.productos.length > 0 ? (
                                  selectedMailData.productos.map(
                                    (producto, index) => (
                                      <tr key={index}>
                                        <td>{producto.title}</td>{" "}
                                        {/* Cambiado de producto.nombre a producto.title */}
                                        <td>{producto.price}</td>{" "}
                                        {/* Cambiado de producto.precio a producto.price */}
                                        <td>
                                          {/* Íconos de acciones */}
                                          <span className="icon-actions">
                                            <i
                                              className="fas fa-minus-circle"
                                              title="Eliminar"
                                              style={{
                                                marginRight: "10px",
                                                cursor: "pointer",
                                              }}
                                            ></i>
                                            <i
                                              className="fas fa-check-circle"
                                              title="Confirmar"
                                              style={{
                                                marginRight: "10px",
                                                cursor: "pointer",
                                              }}
                                            ></i>
                                            <i
                                              className="fas fa-question-circle"
                                              title="FAQ"
                                              style={{ cursor: "pointer" }}
                                            ></i>
                                          </span>
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan="3">
                                      No hay productos asociados
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </CardBody>
                        </Card>
                      </CardGroup>
                    </CardBody>
                  </Card>
                </div>
              </div>
            ) : (
              <div
                className="mailbox-detail-placeholder"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  textAlign: "center",
                }}
              >
                Seleccione un cliente para ver los detalles
              </div>
            )}
          </PerfectScrollbar>
        </div>
      </div>
    </div>
  );
}

export default EmailDetail;
